/* ============================================================
   UAS menu extras - loaded via snippets/uas-menu-toggle.liquid
   Adds utility links BELOW the category list (they scroll with it,
   not pinned). Colours / hover styles live in uas-menu-extras.css.
   ============================================================ */
(function () {
  var LINKS = [
    { href: '/pages/brands', label: 'Shop by Brand',
      icon: '<path d="M3 11.3V4a1 1 0 0 1 1-1h7.3a1 1 0 0 1 .7.3l8 8a1 1 0 0 1 0 1.4l-7.3 7.3a1 1 0 0 1-1.4 0l-8-8a1 1 0 0 1-.3-.7Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7.3" cy="7.3" r="1.4" fill="currentColor"/>' },
    { href: '/products/gift-cards', label: 'Gift Cards',
      icon: '<rect x="3.5" y="8" width="17" height="12.5" rx="1" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M3 8h18M12 8v12.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M12 8C12 8 10.5 4 8.2 4.7 6.5 5.2 7 8 12 8Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M12 8C12 8 13.5 4 15.8 4.7 17.5 5.2 17 8 12 8Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' },
    { href: 'https://universalautospares.com.au/a/track-your-order', label: 'Track my Order',
      icon: '<path d="M3 6.5h11v9H3zM14 9.5h3.5l3 3v3H14z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.7" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="17.5" cy="17.5" r="1.7" fill="none" stroke="currentColor" stroke-width="1.7"/>' },
    { href: '/blogs/news', label: 'Our Blogs',
      icon: '<path d="M5 3.5h8l6 6V20.5H5z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M13 3.5v6h6M8 13h8M8 16.5h8M8 9.5h3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' },
    { href: '/pages/help-centre', label: 'Help Centre',
      icon: '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M9.4 9.2a2.6 2.6 0 0 1 4.6 1.5c0 1.7-2 2-2 3.3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="17" r="1" fill="currentColor"/>' }
  ];

  function build() {
    var html = '';
    for (var i = 0; i < LINKS.length; i++) {
      var l = LINKS[i];
      html += '<li><a class="uas-menu__flink" href="' + l.href + '">' +
        '<svg class="uas-menu__ficon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">' + l.icon + '</svg>' +
        '<span>' + l.label + '</span></a></li>';
    }
    return html;
  }

  function inject() {
    // remove the old pinned footer from the previous version, if present
    var stale = document.querySelector('#uas-menu .uas-menu__footer');
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);

    var rootBody = document.querySelector('#uas-menu .uas-menu__panel[data-panel="root"] .uas-menu__body');
    if (!rootBody) return false;
    if (rootBody.querySelector('.uas-menu__extra')) return true;
    var ul = document.createElement('ul');
    ul.className = 'uas-menu__extra';
    ul.innerHTML = build();
    rootBody.appendChild(ul);
    return true;
  }

  // Category panels load asynchronously (AJAX / cache). Poll briefly until the
  // root panel exists, then inject once. No MutationObserver - writing into a
  // watched subtree has frozen the theme editor before.
  var polling = false;
  function start() {
    if (inject()) return;
    if (polling) return;
    polling = true;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (inject() || tries > 80) { clearInterval(t); polling = false; }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
